<div class="the_container">
  <div class="d-flex justify-content-between align-items-center">
    @if(!isMobile){
    <span class="headingText">DPNF</span>
    }
  </div>
  <!-- <app-dp-tab-menu></app-dp-tab-menu> -->
  <app-dp-tab-menu-v3></app-dp-tab-menu-v3>
  <router-outlet></router-outlet>
</div>